<script setup lang="ts">
import { computed, inject, onBeforeUnmount, onMounted, reactive } from 'vue'

import { TabContainerKey } from './tab-container-context'

const props = withDefaults(defineProps<{
  /** @public Used by parent TabContainer component */
  title: string
  /** @public Used by parent TabContainer component */
  selected?: boolean
}>(), {
  selected: false
})

const tabContainer = inject(TabContainerKey, null)

const tab = reactive({
  title: props.title,
  selected: props.selected,
  isActive: false,
  tabIndex: 0
})

const containerId = computed(() => tabContainer?.containerId.value ?? null)

onMounted(() => {
  tabContainer?.registerTab(tab)
})

onBeforeUnmount(() => {
  tabContainer?.unregisterTab(tab)
})
</script>

<template>
  <div :id="`panel-${containerId}-${tab.tabIndex}`"
       class="bx-tabs__panel"
       :class="{ 'bx-active': tab.isActive }"
       tabindex="-1">
    <slot />
  </div>
</template>
